import { formatPath } from '@/components/fakeDoor/utils';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GarageState {
    selectedGarageData: GarageData | null;
    currentPath: string | null;
}

interface GarageData {
    id: string;
    name: string;
    display_name: string;
    address: string;
    pincode: string;
    rating: string;
    sa_phone_number: string | null;
    sa_name: string | null;
    royalty: number | null;
    is_final_bill_adjustable: boolean | null;
    appointment_pricing: any | null;
    serviceable_pincodes: string[] | null;
    standard_discount: number | null;
    pricing_markup: number | null;
    map_link: string | null;
    reception_number: string;
    is_variable_price_applicable: boolean | null;
    serviceable_make: string[] | null;
    reschedule_window_in_hours: number;
    cancellation_window_in_hours: number;
    appointment_expiration_window_in_minutes: number | null;
    city: string;
}

const initialState: GarageState = {
    selectedGarageData: null,
    currentPath: null,
};

const garageSlice = createSlice({
    name: 'garage',
    initialState,
    reducers: {
        setGarageData: (state, action: PayloadAction<GarageData>) => {
            state.selectedGarageData = action.payload;

            state.currentPath = formatPath(
                action.payload?.city || '',
                action.payload?.display_name || ''
            );
        },
    },
});

export const { setGarageData } = garageSlice.actions;
export default garageSlice.reducer;
